import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { MobileHeaderComponent } from '../../components/mobile-header/mobile-header.component';
import { Inject, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-validate-email',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    SidebarComponent,
    MobileHeaderComponent,
    TranslateModule
  ],
  templateUrl: './validate-email.component.html',
  styleUrls: ['./validate-email.component.scss']
})
export class ValidateEmailComponent implements OnInit {
  email: string | null = null;
  isLoading: boolean = false;
  emailSent: boolean = false;
  redirect_to_buy: boolean = false;

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, @Inject(PLATFORM_ID) private platformId: Object ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.redirect_to_buy = params['redirect_to_buy'] === '1' || params['redirect_to_buy'] === 1;
    });


    // Reload confirmation every 2 seconds
    if (isPlatformBrowser(this.platformId)) {
      setInterval(() => {
        this.reloadConfirmation();
      }, 2000);
    }
  }

  resendVerificationEmail() {
    if (this.email) {
      this.isLoading = true;
      this.http.post(`${environment.url}/api/v1/company/resend_verification`, { email: this.email, redirect_to_buy: this.redirect_to_buy ? 1 : 0 })
        .subscribe({
          next: (response) => {
            this.isLoading = false;
            this.emailSent = true;
          },
          error: (error) => console.error('Error resending email:', error)  
        });
    } else {
      console.error('Email is required to resend verification');
    }
  }


  reloadConfirmation() {

    const email = this.email;

    this.http.get(`${environment.url}/api/v1/company/email_confirmed?email=${email}`)
      .subscribe({
        next: (response : any) => {
          const res = response['email_confirmed'];
          if (res) {
            const token = response['access_token'];
            document.cookie = `access_token=${token}; path=/;`;
            if (this.redirect_to_buy) {
              this.router.navigate(['/dashboard/company/compass/buy'], { queryParams: { from_validate_email: 1 } });
            } else {
              this.router.navigate(['/dashboard/company']);
            }
          }
        },
        error: (error) => console.error('Error reloading confirmation:', error)
      });
  }
}
